export default {
  '1': {
    migration: [
      { op: 'add', path: '/version', value: 1 },
      { op: 'add', path: '/indexRoute', value: 'prelive' },
      { op: 'add', path: '/login.termsCheck', value: false },
      { op: 'add', path: '/registration.type', value: 'basic' },
      { op: 'add', path: '/registration.passwordStrength', value: 'low' },
      { op: 'add', path: '/translations.api', value: 'https://i18n.bettings.ch' },
      { op: 'add', path: '/translations.token', value: '' },
      { op: 'add', path: '/sportsbook.live.source', value: 0 },
      { op: 'add', path: '/sportsbook.prelive.source', value: 0 },
      { op: 'add', path: '/sportsbook.betslip.parlayLimit', value: 20 },
      { op: 'add', path: '/sportsbook.betslip.doubleChanceLimit', value: true },
      { op: 'add', path: '/competition.source', value: 0 },
      { op: 'add', path: '/exchange.source', value: 0 },
      { op: 'add', path: '/sessionGames.adminToken', value: '' },
      { op: 'add', path: '/exchanges.bets.defaults.enabled', value: false },
      { op: 'add', path: '/exchanges.bets.quick.enabled', value: false },
      { op: 'add', path: '/exchanges.bets.confirm.enabled', value: true },
      { op: 'add', path: '/exchanges.bets.confirm.default', value: true },
      { op: 'add', path: '/exchanges.markets.open.count', value: 4 },
      { op: 'add', path: '/exchanges.multimarkets.enabled', value: true },
      { op: 'add', path: '/exchanges.lowLiquidityCheck.enabled', value: false },
      { op: 'add', path: '/exchanges.lowLiquidityCheck.minTotalMatched', value: 5000 },
      { op: 'add', path: '/exchanges.lowLiquidityCheck.minTotalAvailable', value: 500 },
      { op: 'add', path: '/exchanges.realLiquidity.show', value: false },
      { op: 'add', path: '/btsAdmin.url', value: 'https://dev.bts-admin.bettings.ch' },
      { op: 'add', path: '/services.recaptcha.key', value: '' },
      { op: 'add', path: '/services.googleAnalytics.key', value: '' },
      { op: 'add', path: '/services.affiliateSystem.enabled', value: false },
    ],
  },
  '2': {
    migration: [
      { op: 'replace', path: '/version', value: 2 },
      { op: 'add', path: '/permissions', value: {} },
    ],
  },
  '3': {
    migration: [
      { op: 'replace', path: '/version', value: 3 },
      { op: 'remove', path: '/services.affiliateSystem.enabled' },
    ],
  },
  '4': {
    migration: [{ op: 'replace', path: '/version', value: 4 }],
  },
  '5': {
    migration: [
      { op: 'replace', path: '/version', value: 5 },
      { op: 'add', path: '/sportsbook.sources', value: [] },
      { op: 'remove', path: '/sportsbook.live.source' },
      { op: 'remove', path: '/sportsbook.prelive.source' },
    ],
  },
  '6': {
    migration: [
      { op: 'replace', path: '/version', value: 6 },
      { op: 'add', path: '/theme', value: '24betting' },
    ],
  },
  '7': {
    migration: [
      { op: 'replace', path: '/version', value: 7 },
      {
        op: 'add',
        path: '/user.fields',
        value: {
          username: { registration: true, account: true, required: true, editable: false },
          password: { registration: true, account: true, required: true, editable: false },
          gender: { registration: true, account: true, required: true, editable: false },
          firstName: { registration: true, account: true, required: true, editable: false },
          lastName: { registration: true, account: true, required: true, editable: false },
          birthday: { registration: true, account: true, required: true, editable: false },
          currency: { registration: true, account: true, required: true, editable: false },
          code: { registration: false, account: true, required: false, editable: false },
          country: { registration: true, account: true, required: true, editable: false },
          city: { registration: true, account: true, required: true, editable: false },
          zip: { registration: true, account: true, required: true, editable: false },
          street: { registration: true, account: true, required: true, editable: false },
          email: { registration: true, account: true, required: true, editable: false },
          phone: { registration: true, account: true, required: true, editable: true },
          acceptTerms: { registration: true, account: true, required: true, editable: false },
        },
      },
    ],
  },
  '8': {
    migration: [
      { op: 'replace', path: '/version', value: 8 },
      { op: 'add', path: '/verification.notification', value: false },
      { op: 'add', path: '/sessionGames.automateGames', value: false },
      { op: 'add', path: '/currencies.visible', value: true },
    ],
    update(data, stage) {
      switch (stage) {
        case 'dev':
          return { ...data, 'btsAdmin.url': 'https://dev.bts-admin.bettings.ch' }
        case 'prod':
          return { ...data, 'btsAdmin.url': 'https://bts-admin.bettings.ch' }
      }
    },
  },
  '9': {
    migration: [{ op: 'replace', path: '/version', value: 9 }],
    update(data, stage) {
      switch (stage) {
        case 'dev':
          return { ...data, 'bts.printUrl': 'https://dev.sbpdf.bettings.ch' }
        case 'prod':
          return { ...data, 'bts.printUrl': 'https://sbpdf.bettings.ch' }
      }
    },
  },
  '10': {
    migration: [{ op: 'replace', path: '/version', value: 10 }],
    update(data, stage) {
      const devAPI = {
        'sportsbook.api': 'https://dev.sbapi.bettings.ch/api/v2/',
        'exchange.api': 'https://dev.sbapi.bettings.ch/api/v2/',
        'competition.api': 'https://dev.sbapi.bettings.ch/api/v2/',
        'dabba.api': 'https://dev.dabbaexch.bettings.ch/api/',
        'betfair.api': 'https://dev.bfgw.bettings.ch/api/',
        'sessionGames.api': 'https://dev.sgapi.bettings.ch/',
        'matchbook.api': 'https://dev.mbgw.bettings.ch/edge/rest/',
      }

      const prodAPI = {
        'sportsbook.api': 'https://sbapi.bettings.ch/api/v2',
        'exchange.api': 'https://sbapi.bettings.ch/api/v2',
        'competition.api': 'https://sbapi.bettings.ch/api/v2',
        'dabba.api': 'https://dabbaexch.bettings.ch/api/',
        'betfair.api': 'https://api.betsoho.com/api/',
        'sessionGames.api': 'https://sgapi.bettings.ch',
        'matchbook.api': 'https://mbgw.bettings.ch/edge/rest/',
      }

      switch (stage) {
        case 'dev':
          return { ...data, ...devAPI }
        case 'prod':
          return { ...data, ...prodAPI }
      }
    },
  },
  '11': {
    migration: [
      { op: 'replace', path: '/version', value: 11 },
      { op: 'replace', path: '/sessionGames.automateGames', value: true },
    ],
  },
  '12': {
    migration: [{ op: 'replace', path: '/version', value: 12 }],
    update(data, stage) {
      const devAPI = {
        'sportsbook.api': 'https://dev.sbapi.bettings.ch/api/',
        'exchange.api': 'https://dev.sbapi.bettings.ch/api/',
        'competition.api': 'https://dev.sbapi.bettings.ch/api/',
      }

      const prodAPI = {
        'sportsbook.api': 'https://sbapi.bettings.ch/api/',
        'exchange.api': 'https://sbapi.bettings.ch/api/',
        'competition.api': 'https://sbapi.bettings.ch/api/',
      }

      switch (stage) {
        case 'dev':
          return { ...data, ...devAPI }
        case 'prod':
          return { ...data, ...prodAPI }
      }
    },
  },
  '13': {
    migration: [{ op: 'replace', path: '/version', value: 13 }],
    update(data, stage) {
      const devAPI = {
        'sportsbook.api': 'https://dev.sbapi.bettings.ch/api',
        'exchange.api': 'https://dev.sbapi.bettings.ch/api',
        'competition.api': 'https://dev.sbapi.bettings.ch/api',
        'dabba.api': 'https://dev.dabbaexch.bettings.ch/api',
        'betfair.api': 'https://dev.bfgw.bettings.ch/api',
        'sessionGames.api': 'https://dev.sgapi.bettings.ch',
        'matchbook.api': 'https://dev.mbgw.bettings.ch/edge/rest',
      }

      const prodAPI = {
        'sportsbook.api': 'https://sbapi.bettings.ch/api',
        'exchange.api': 'https://sbapi.bettings.ch/api',
        'competition.api': 'https://sbapi.bettings.ch/api',
        'dabba.api': 'https://dabbaexch.bettings.ch/api',
        'betfair.api': 'https://api.betsoho.com/api',
        'sessionGames.api': 'https://sgapi.bettings.ch',
        'matchbook.api': 'https://mbgw.bettings.ch/edge/rest',
      }

      switch (stage) {
        case 'dev':
          return { ...data, ...devAPI }
        case 'prod':
          return { ...data, ...prodAPI }
      }
    },
  },
  '14': {
    migration: [
      { op: 'replace', path: '/version', value: 14 },
      { op: 'add', path: '/login.required', value: false },
    ],
  },
  '15': {
    migration: [
      { op: 'replace', path: '/version', value: 15 },
      { op: 'add', path: '/poolbetting.api', value: '' },
      { op: 'add', path: '/poolbetting.adminToken', value: '' },
    ],
  },
  '16': {
    migration: [
      { op: 'replace', path: '/version', value: 16 },
      {
        op: 'move',
        from: '/exchanges.lowLiquidityCheck.enabled',
        path: '/betfair.lowLiquidityCheck.enabled',
      },
      {
        op: 'move',
        from: '/exchanges.lowLiquidityCheck.minTotalMatched',
        path: '/betfair.lowLiquidityCheck.minTotalMatched',
      },
      {
        op: 'move',
        from: '/exchanges.lowLiquidityCheck.minTotalAvailable',
        path: '/betfair.lowLiquidityCheck.minTotalAvailable',
      },
    ],
  },
  '17': {
    migration: [
      { op: 'replace', path: '/version', value: 17 },
      { op: 'add', path: '/oneClickBetting.enabled', value: false },
      { op: 'add', path: '/matchbook.showLiquidityEverywhere', value: true },
      { op: 'add', path: '/betfair.showLiquidityEverywhere', value: true },
      { op: 'add', path: '/exchange.showLiquidityEverywhere', value: true },
    ],
  },
  '18': {
    migration: [
      { op: 'replace', path: '/version', value: 18 },
      // betfair
      { op: 'add', path: '/betfair.prefixUrl', value: '/exchange' },
      { op: 'add', path: '/betfair.prelive.enabled', value: true },
      { op: 'add', path: '/betfair.prelive.title', value: 'Home' },
      { op: 'add', path: '/betfair.live.enabled', value: true },
      { op: 'add', path: '/betfair.live.title', value: 'Inplay' },
      // dabba
      { op: 'add', path: '/dabba.prefixUrl', value: '/exchange' },
      { op: 'add', path: '/dabba.prelive.enabled', value: true },
      { op: 'add', path: '/dabba.prelive.title', value: 'Home' },
      { op: 'add', path: '/dabba.live.enabled', value: true },
      { op: 'add', path: '/dabba.live.title', value: 'Inplay' },
      { op: 'add', path: '/dabba.showLiquidityEverywhere', value: true },
      // exchange
      { op: 'add', path: '/exchange.prefixUrl', value: '/exchange' },
      { op: 'add', path: '/exchange.prelive.enabled', value: true },
      { op: 'add', path: '/exchange.prelive.title', value: 'Home' },
      { op: 'add', path: '/exchange.live.enabled', value: true },
      { op: 'add', path: '/exchange.live.title', value: 'Inplay' },
      // matchbook
      { op: 'add', path: '/matchbook.prefixUrl', value: '/exchange' },
      { op: 'add', path: '/matchbook.prelive.enabled', value: true },
      { op: 'add', path: '/matchbook.prelive.title', value: 'Home' },
      { op: 'add', path: '/matchbook.live.enabled', value: true },
      { op: 'add', path: '/matchbook.live.title', value: 'Inplay' },
    ],
  },
  '19': {
    migration: [
      { op: 'replace', path: '/version', value: 19 },
      { op: 'remove', path: '/exchange.source' },
      { op: 'remove', path: '/exchange.prefixUrl' },
      { op: 'remove', path: '/exchange.prelive.enabled' },
      { op: 'remove', path: '/exchange.prelive.title' },
      { op: 'remove', path: '/exchange.live.enabled' },
      { op: 'remove', path: '/exchange.live.title' },
      { op: 'add', path: '/exchange.sources', value: [] },
    ],
  },
  '20': {
    migration: [
      { op: 'replace', path: '/version', value: 20 },
      { op: 'add', path: '/responsibleGambling', value: false },
    ],
  },
  '21': {
    migration: [
      { op: 'replace', path: '/version', value: 21 },
      { op: 'add', path: '/displayCurrency', value: true },
    ],
  },
  '22': {
    migration: [
      { op: 'replace', path: '/version', value: 22 },
      { op: 'add', path: '/streak.api', value: '' },
      { op: 'add', path: '/streak.token', value: '' },
    ],
  },
  '23': {
    migration: [
      { op: 'replace', path: '/version', value: 23 },
      { op: 'add', path: '/sportsbook.betslip.maxStake', value: false },
    ],
  },
  '24': {
    migration: [
      { op: 'replace', path: '/version', value: 24 },
      { op: 'add', path: '/betfair.betslip.submitDelay', value: 0 },
      { op: 'add', path: '/dabba.betslip.submitDelay', value: 0 },
      { op: 'add', path: '/matchbook.betslip.submitDelay', value: 0 },
      { op: 'add', path: '/exchange.betslip.submitDelay', value: 0 },
      { op: 'add', path: '/sessionGames.betslip.submitDelay', value: 0 },
      { op: 'add', path: '/sportsbook.betslip.submitDelay', value: 0 },
      { op: 'add', path: '/poolbetting.betslip.submitDelay', value: 0 },
    ],
  },
  '25': {
    migration: [
      { op: 'replace', path: '/version', value: 25 },
      { op: 'add', path: '/neverBounce.apiKey', value: '' },
    ],
  },
  '26': {
    migration: [
      { op: 'add', path: '/intercom.publicAppId', value: '' },
      { op: 'add', path: '/intercom.options', value: [] },
    ],
  },
  '27': {
    migration: [{ op: 'add', path: '/widgets.matchProgress', value: '' }],
  },
  '28': {
    migration: [{ op: 'add', path: '/moneyTransfer.enabled', value: false }],
  },
}



// WEBPACK FOOTER //
// ./src/components/Projects/Form/Frontend/migrations.mjs